export default __webpack_public_path__ + "static/1707-913a47ea312d370547aba58016bf465f.gif";